import { z } from 'zod';
import { JobUserInfoSchema } from './jobUserInfoSchema';
import { OrganizationSimpleSchema } from '../organization/organizationSimpleSchema';
export const JobSimpleSchema = z.object({
    id: z.number(),
    title: z.string(),
    isActive: z.boolean().optional(),
    location: z.string(),
    slug: z.string().optional(),
    endsAt: z.date().optional(),
    organization: z.string().or(OrganizationSimpleSchema),
    description: z.string().optional(),
    isEndNear: z.boolean().optional(),
    userInfo: JobUserInfoSchema.optional(),
    externalDetailsUrl: z.string().optional()
});
//# sourceMappingURL=jobSimpleSchema.js.map